module.exports = __webpack_public_path__ + "03_glasses_black.c62eb7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/03_glasses_black.png
// module id = WS2q
// module chunks = 0